
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lecture/embed/[id]",
      function () {
        return require("private-next-pages/lecture/embed/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lecture/embed/[id]"])
      });
    }
  